var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonIconRounded.class,attrs:{"data-tooltip-text":_vm.buttonIconRounded.tooltip,"type":_vm.buttonIconRounded.type},on:{"click":function($event){return _vm.click()}}},[_c('i',{class:_vm.buttonIconRounded.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }